package org.chiangmeng.qfast.core.domain.models

// Data model representing shop status and details
data class Shop(
    val id: String,
    val name: String,
    val currentServings: Map<String, Int>,
    val lastTicket: Int,
    val isActive: Boolean,
    val updatedAt: Long,
    val adText: String? = null,
    val menuUrl: String? = null,
    val openTime: String? = null,
    val closeTime: String? = null,
    val theme: String? = null,
    val categories: Map<String, String>? = null
)
